<template>
  <el-form  :rules="rules" ref="ethernetForm" :model="comms" label-width="50%" label-position="left">
    <el-form-item label="Ethernet name :" prop="name">
      <el-input :disabled="true" style="width:70%" v-model="comms.name"/>
    </el-form-item>
    <el-form-item label="Url :" prop="url">
      <el-input :disabled="true" style="width:70%" v-model="comms.url"/>
    </el-form-item>

  </el-form>
</template>

<script>
  import { post } from "../../../../../API/cloudFunctions";

  export default {
    created() {
      if (this.$store.getters.smtpConfig) {
        this.smtp = this.$store.getters.smtpConfig;
      }
    },
    name: "ethernet",
    data() {
      return {
        comms: {
          name: "web",
          url:
            "https://us-central1-tisalabs-iot-platform-dev.cloudfunctions.net/"

        },
        rules: {
          name: {
            required: true,
            message: "Please provide a Name !"
          },
          url: { required: true }
        },
        loading: false,
        disablePassword: true,
        sendingTestEmail: false,
        sent: false
      };
    },
    methods: {}
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/ethernet.vue